import { VehicleHistoryActionsComponent } from './vehicle.imported-history.actions.component';
import VehicleHistoryNotesHtml            from './templates/vehicle.imported-history.notes.html';

export function VehicleImportedHistoryCtrl (
  $uibModal,
  $scope,
  $translate,
  $window,
  API,
  tableApi,
  workshopAPI
) {
  $scope.showVehicleHistory = !!$scope.invoices.length;
  $scope.tableCacheKey      = 'vehicleHistory';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'invoice_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'invoice_total',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onPrintClick: event => $scope.viewInvoice(event),
              onNotesClick: event => $scope.viewNotes(event)
            }
          },
          enabled: true,
          factory: VehicleHistoryActionsComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_HISTORY_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 20, 50 ],
      queryCount: () => workshopAPI.get('/vehicles/vehicle_history_list_count', [
        $scope.vehicle.id,
      ])
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    })
  };

  $scope.viewNotes = function(row) {
    $uibModal.open({
      templateUrl: VehicleHistoryNotesHtml,
      windowClass: 'lg-modal',
      resolve    : {
        item: function () {
          return row.entity;
        }
      },
      controller: 'VehicleViewHistoryNotesCtrl'
    });

  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/vehicles/vehicle_history_list', [
      $scope.vehicle.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(invoices => {
      $scope.invoices = invoices;

      return invoices;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewInvoice(event.row);
  };

  $scope.viewInvoice = function (invoice) {
    $window.open(`${API.url}/reports/history_report/${invoice.id}.pdf`, '_blank' );
  };
};
